import { createAction as createRtkAction } from "@reduxjs/toolkit";

/**
 * Curried action creators that keep the call shape the store used to get from `typesafe-actions`
 * (unmaintained since 2022 and incompatible with Redux 5's `Action<string>` typing), implemented
 * on top of Redux Toolkit's `createAction`.
 *
 *   createAction(TYPE)()          // () => { type }
 *   createAction(TYPE)<Payload>() // (payload: Payload) => { type, payload }
 */
export const createAction =
  (type: string) =>
  <Payload = void>() =>
    createRtkAction<Payload>(type);

/**
 *   createAsyncAction(REQUEST, SUCCESS, FAILURE)<Request, Success, Failure>()
 *     // => { request, success, failure }
 */
export const createAsyncAction =
  (requestType: string, successType: string, failureType: string) =>
  <Request = void, Success = void, Failure = Error>() => ({
    request: createRtkAction<Request>(requestType),
    success: createRtkAction<Success>(successType),
    failure: createRtkAction<Failure>(failureType),
  });
